import * as types from '../dashboardActionTypes';

export default (state = true, action) => {
    switch(action.type) {
        case types.LOAD_INCIDENTS:
            return true;
        case types.LOAD_INCIDENTS_FAILED:
        case types.LOAD_INCIDENTS_SUCCESS:
            return false;
        default:
            return state;        
    }
};


// WEBPACK FOOTER //
// ./src/dashboard/reducers/incidentsLoadingReducer.js